import './DialogMsg.css';
import React, { useState, useEffect } from 'react';


function DialogMsg(props) {

	const [open, setOpen] = useState(null);
	const [lastConf, setLastConf] = useState(null);


	useEffect(() => {
		// Similar to componentDidMount and componentDidUpdate:
		setOpen(props.conf !== lastConf ? true : false);
		setLastConf(props.conf)
	}, [props.conf]); //empty array => chiama solo una volta. Senza la chiama ad ogni cambiamento

	function handleOK() {
		setOpen(false);
		if (props.conf.handleOK) props.conf.handleOK();
	}

	function handleKO() {
		setOpen(false);
		if (props.conf.handleKO) props.conf.handleKO();
	}

	function formatDesc() {
		let rows = props.conf && props.conf.description && props.conf.description !== null ? props.conf.description.split("<br>") : [];
		return rows;
	}

	return (
		<div className={`iol-dlgmsg-overlay ${open && "eliminate-open"} `}>
			<div className="iol-dlgmsg-overlay-content">
				<div className="iol-weapper">
					<div className="iol-dlgmsg-box">
						<p className={`heading-4 fucsia-text semibold ${(props.conf.dimension === 'small') ? "dlgSmallTit" : ""}`}>{props.conf != null && props.conf.title}</p>
						<div className={`heading-5 semibold`}>
						{formatDesc().map((row, index) => (
							<p className={(props.conf.dimension === 'small') ? "dlgSmallDesc": "semibold"} key={index}>{row}</p>
						))}
						{(props.conf != null && props.conf.srvCln) && <> Contatta il servizio clienti al numero <a href="tel:800011411" rel="noopener"><strong>800 011 411</strong></a> per maggiori informazioni.</>}
						</div>
						{(props.conf != null && props.conf.acOKLbl !== null && props.conf.acOKLbl.length > 0) && <button onClick={() => { handleOK() }} className="fucsia-button link">{props.conf != null && props.conf.acOKLbl}</button>}
						{(props.conf != null && props.conf.acKOLbl !== null && props.conf.acKOLbl.length > 0) && <button onClick={() => { handleKO() }} className="white-button link">{props.conf != null && props.conf.acKOLbl}</button>}
					</div>
				</div>
			</div>
		</div>
	);
}

export default DialogMsg;
